import { useState } from "react";
import Stack from "@mui/material/Stack";
import FinanceiroFiltroPeriodo, {
  type PeriodoRapido,
} from "./components/FinanceiroFiltroPeriodo";
import FinanceiroResumoCards from "./components/FinanceiroResumoCards";
import FinanceiroLoading from "./components/FinanceiroLoading";
import FinanceiroEmptyState from "./components/FinanceiroEmptyState";
import FinanceiroErrorState from "./components/FinanceiroErrorState";
import { useDashboardFinanceiro } from "./hooks/useDashboardFinanceiro";

/**
 * Dashboard financeiro geral — GET /loja/financeiro/dashboard
 */
export default function DashboardFinanceiroPage() {
  const {
    data,
    loading,
    error,
    filtros,
    filtrosAplicados,
    setFiltros,
    aplicarFiltros,
    setTipoDataInscricoes,
    refetch,
    isEmpty,
  } = useDashboardFinanceiro();

  const [periodoRapido, setPeriodoRapido] = useState<PeriodoRapido>("mes");

  const showSkeletonInicial = !error && loading && !data;
  const showConteudo = !error && !showSkeletonInicial;

  return (
    <Stack spacing={3}>
      <FinanceiroFiltroPeriodo
        filtros={filtros}
        onChange={setFiltros}
        onApply={aplicarFiltros}
        periodoRapido={periodoRapido}
        onPeriodoRapidoChange={setPeriodoRapido}
        showGranularidade={false}
      />

      {error ? (
        <FinanceiroErrorState message={error} onRetry={refetch} />
      ) : null}

      {showSkeletonInicial ? <FinanceiroLoading /> : null}

      {showConteudo ? (
        <>
          {isEmpty ? <FinanceiroEmptyState /> : null}
          <FinanceiroResumoCards
            vm={data}
            loading={loading}
            filtrosAplicados={filtrosAplicados}
            onTipoDataInscricoesChange={setTipoDataInscricoes}
          />
        </>
      ) : null}
    </Stack>
  );
}
